import { OnInit, } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Datastore, } from '@freelancer/datastore';
import { CardSize } from '@freelancer/ui/card';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { TextSize } from '@freelancer/ui/text';
import { toNumber } from '@freelancer/utils';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';
var HireMeWebappModalComponent = /** @class */ (function () {
    function HireMeWebappModalComponent(auth, datastore) {
        this.auth = auth;
        this.datastore = datastore;
        this.HeadingColor = HeadingColor;
        this.HeadingType = HeadingType;
        this.TextSize = TextSize;
        this.CardSize = CardSize;
    }
    HireMeWebappModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.profileViewUsersDocument = this.datastore.document('profileViewUsers', this.profileUserId);
        var usersDoc = this.datastore.document('users', this.auth.getUserId());
        var loggedUserHasProjects$ = this.datastore
            .collection('projects', function (query) {
            return query
                .where('ownerId', '==', _this.auth.getUserId().pipe(map(function (id) { return toNumber(id); })))
                .limit(1);
        })
            .valueChanges()
            .pipe(map(function (projects) { return projects.length > 0; }));
        this.hireMeUser$ = Rx.combineLatest([
            this.profileViewUsersDocument.valueChanges(),
            usersDoc.valueChanges(),
            loggedUserHasProjects$,
        ]).pipe(map(function (_a) {
            var profileUser = _a[0], loggedInUser = _a[1], loggedUserHasProjects = _a[2];
            return ({
                authId: loggedInUser.id,
                profileUserId: profileUser.id,
                isDeloitteDcUser: !!profileUser.isDeloitteDcUser,
                profileUserDisplayName: profileUser.publicName || profileUser.username,
                paymentVerified: loggedInUser.status
                    ? loggedInUser.status.paymentVerified
                    : false,
                emailVerified: loggedInUser.status
                    ? loggedInUser.status.emailVerified
                    : false,
                defaultCurrency: loggedInUser.currency,
                loggedUserIsRookie: !loggedUserHasProjects,
                profileUserHourlyRate: profileUser.hourlyRate,
            });
        }));
    };
    return HireMeWebappModalComponent;
}());
export { HireMeWebappModalComponent };
